import styled from 'styled-components';

export const InstructionsWrapper = styled.div`
	background-color: #ffffff;
	height: 100%;
	width: 100%;
	padding: 20px;
`;

export const InstructionHeader = styled.div`
	font-weight: 500;
	font-size: 19px;
`;

export const Instruction = styled.li`
	list-style: ${props => (props.type === 'string' ? 'disc' : 'none')};
	padding-top: 10px;
`;

export const InstructionList = styled.ul`
	padding: 5px 10px 10px 30px;
`;

export const BoldText = styled.span`
	font-weight: 500;
`;

export const ColsList = styled.ul`
	padding-left: 20px;
`;

export const ColName = styled.li`
	padding-top: 10px;
	padding-left: 10px;
	list-style: circle;
`;
